import { Box, Heading, Table, TableContainer, Tbody, Td, Tfoot, Th, Thead, Tr } from '@chakra-ui/react'

import { formatCurrency } from '../../../helpers'
import { IPrizeSummaryItem } from '../../../services/SalesReceipt/SalesReceiptService'

interface ISalesReceiptPrizeSummaryProps {
  items: IPrizeSummaryItem[]
}

function SalesReceiptPrizeSummary({ items }: ISalesReceiptPrizeSummaryProps) {
  if (items.length === 0) return null

  const totalValue = items.reduce((sum, item) => sum + item.total_value, 0)
  const totalPrize = items.reduce((sum, item) => sum + item.total_prize, 0)
  const totalQuantity = items.reduce((sum, item) => sum + (item.quantity ?? 0), 0)

  return (
    <Box borderWidth="1px" borderRadius="md" p="3" mb="4" maxW="480px">
      <Heading mb="2">Prêmios do Mês</Heading>
      {/* Capped height with sticky header/footer so a long month stays compact and the totals
          remain visible while scrolling. */}
      <TableContainer maxH="240px" overflowY="auto">
        <Table>
          <Thead position="sticky" top="0" zIndex="1" bg="chakra-body-bg">
            <Tr>
              <Th>Consultor</Th>
              <Th isNumeric>Qtde</Th>
              <Th isNumeric>Vendido à Vista</Th>
              <Th isNumeric>Prêmio</Th>
            </Tr>
          </Thead>
          <Tbody>
            {items.map((item) => (
              <Tr key={item.consultant_name}>
                <Td>{item.consultant_name}</Td>
                <Td isNumeric>{item.quantity ?? 0}</Td>
                <Td isNumeric>{formatCurrency(item.total_value)}</Td>
                <Td isNumeric>{formatCurrency(item.total_prize)}</Td>
              </Tr>
            ))}
          </Tbody>
          <Tfoot position="sticky" bottom="0" bg="chakra-body-bg">
            <Tr>
              <Th>Total</Th>
              <Th isNumeric>{totalQuantity}</Th>
              <Th isNumeric>{formatCurrency(totalValue)}</Th>
              <Th isNumeric>{formatCurrency(totalPrize)}</Th>
            </Tr>
          </Tfoot>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default SalesReceiptPrizeSummary
